document.addEventListener("DOMContentLoaded", function () {

    const btn = document.getElementById("whatsapp-product-button");

    if (!btn) return;

    btn.addEventListener("click", function () {

    if (btn.disabled) return;

    btn.disabled = true;

    const textoOriginal = btn.innerHTML;

    btn.innerHTML = "⏳ Preparando WhatsApp...";

        const product = window.meta.product;

        let variantId = document.querySelector('input[name="id"]')?.value;

        let variant = product.variants.find(v => String(v.id) === String(variantId));

        if (!variant) {
            variant = product.variants[0];
        }

        // Cantidad seleccionada
console.log("Variant ID:", variantId);
console.log("Variant:", variant);
        let qty = document.querySelector('input[name="quantity"]')?.value || 1;

        const precio = (variant.price / 100).toFixed(2);
        const total = (variant.price * qty / 100).toFixed(2);

        const mensaje =
`👋 Hola.

Me interesa este producto.

🛍️ Producto: ${variant.name}

📦 Cantidad: ${qty}

💲 Precio unitario: $${precio}

💰 Total: $${total}

🔗 ${location.origin}/products/${product.handle}`;

   const ventana = window.open(
    "https://wa.me/5218123243696?text=" +
    encodeURIComponent(mensaje),
    "_blank"
);

if (!ventana) {
    alert("El navegador bloqueó la apertura de WhatsApp. Permite las ventanas emergentes.");
}

btn.disabled = false;
btn.innerHTML = textoOriginal;

    });

});